import {useState} from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { signup } from '../../api/api';
import './Signup.css';

function Signup() {
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');


  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if(password != confirmPassword){
      setError("Password did not match try again");
      return;
    }
    try{
      const [firstName, ...rest] = name.trim().split(' ');
      const lastName = rest.join(' ') || undefined;
      const data = await signup({ email, password, firstName, lastName });
      localStorage.setItem('token', data.token);
      localStorage.setItem('user', JSON.stringify({ email: data.email, firstName: data.firstName, lastName: data.lastName }));
      navigate('/dashboard');
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className="signup-wrapper">
      <div className="signup-card">
        <div className="signup-logo">
          <svg width="24" height="24" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="14" cy="8" r="5" fill="#6C63FF" />
            <circle cx="7" cy="20" r="4" fill="#6C63FF" opacity="0.6" />
            <circle cx="21" cy="20" r="4" fill="#6C63FF" opacity="0.6" />
          </svg>
          <span className="signup-logo-text">AttendX</span>
        </div>

        <h1 className="signup-title">Create account</h1>
        <p className="signup-subtitle">Get started with EventInvite</p>

        <form className="signup-form" onSubmit={handleSubmit}>
          <div className="signup-field">
            <label>Full Name</label>
            <input type="text" placeholder="John Doe" value={name} onChange={(e) => setName(e.target.value)} required />
          </div>

          <div className="signup-field">
            <label>Email</label>
            <input type="email" placeholder="you@example.com" value={email} onChange={(e) => setEmail(e.target.value)} required />
          </div>

          <div className="signup-field">
            <label>Password</label>
            <input type="password" placeholder="••••••••" value={password} onChange={(e) => setPassword(e.target.value)} required />
          </div>

          <div className="signup-field">
            <label>Confirm Password</label>
            <input type="password" placeholder="••••••••" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} required />
          </div>

          {error && <p className="signup-error">{error}</p>}

          <button type="submit" className="signup-btn">Create Account</button>
        </form>

        <p className="signup-footer">
          Already have an account? <Link to="/login">Sign in</Link>
        </p>
      </div>
    </div>
  );
}

export default Signup;
